import { hideSpinner } from 'action/spinner'
import API_URL from 'constants/api'
import { EventSourcePolyfill } from 'event-source-polyfill';

export function actionSet (type, payload) {
  return payload || typeof payload === 'boolean' ? { type, payload } : { type }
}

export function resolve (dispatch, type, payload) {
  dispatch(actionSet(type, payload))
  return Promise.resolve(payload)
}

export function reject (dispatch, type, payload) {
  dispatch(actionSet(type, payload))
  return Promise.reject(payload)
}

export const setupNewEventSource = (
  reportKey,
  dispatch,
  successCallback,
  errorCallback
) => {
  const eventSource = new EventSourcePolyfill(`${API_URL.ENABLE_NOTIFIER}?reportKey=${reportKey}`, {headers: {
    apiKey: process.env.API_KEY,
    'Cookie': `reportKey=${reportKey}`,
  } })
  
  eventSource.onmessage = event => {
    if (event && event.data !== "connected") {
      const response = JSON.parse(event.data)

      dispatch(hideSpinner())
      if (response.data) {
        successCallback(response)
      } else if (response.message) {
        errorCallback(response)
      }

      eventSource.close()
    }
  }

  eventSource.onerror = e => {
    console.log('EventSource error')
    console.log(e)
    // eventSource.close()
    // setupNewEventSource(reportKey, dispatch, successCallback)
  }
}
